export const BottomSheetHeights = {
    NONE: 0,
    CLOSED: 5,
    SMALL: 20,
    HALF: 50,
    FULL: 98,
}